export default __webpack_public_path__ + "static/media/arro.6cc4d2d8.png";